import type { FC } from 'react';
import React from 'react';

export const FlagIcon: FC = () => (
    <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth="0"
        viewBox="0 0 512 512"
        height="1em"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path id="svg_6" d="m433,20.5l2,434l-435,-5l433,-429z" color="transparent" fill="#fff" />
        <line
            stroke="null"
            strokeLinecap="round"
            strokeLinejoin="round"
            y2="429.57619"
            x2="432"
            y1="17.5"
            x1="432"
            strokeWidth="32"
            fill="none"
        />
        <line
            stroke="null"
            strokeLinecap="round"
            strokeLinejoin="round"
            y2="17.90512"
            x2="429.59493"
            y1="431.50006"
            x1="15.99999"
            strokeWidth="32"
            fill="none"
        />
    </svg>
);

export default FlagIcon;
